import type { AjaxIntegrationResponse } from "./types"

const ENDPOINT = "/site/ajax-integration"

let cached: Promise<AjaxIntegrationResponse> | null = null

/**
 * Fetch the catalog of available integrations + per-tenant pricing flags.
 * Cached for the lifetime of the page — list rarely changes mid-session.
 */
export function fetchCatalog(): Promise<AjaxIntegrationResponse> {
  if (cached) return cached
  cached = fetch(ENDPOINT, {
    credentials: "include",
    headers: { Accept: "application/json" },
  })
    .then(async (res) => {
      if (!res.ok) throw new Error(`Catalog fetch failed: ${res.status}`)
      return (await res.json()) as AjaxIntegrationResponse
    })
    .catch((err) => {
      cached = null
      throw err
    })
  return cached
}

/** Force-refresh on next call. */
export function invalidateCatalog(): void {
  cached = null
}
